import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ADMIN_ACCESS_STEPS, AuthNote, AuthSteps, AuthSuccessBadge } from 'layouts/auth';
import type { AuthStepItem } from 'layouts/auth';
import { paths } from 'routes/routes';
import styles from './register.module.scss';

/**
 * Bước 3/3: tài khoản đã xác minh (vai trò USER). Nói thẳng rằng cần Admin cấp quyền, kèm đúng
 * 3 bước của trang Yêu cầu quyền truy cập (phương án B) để hai nơi nói cùng một câu.
 */
const DoneStep = ({ email }: { email: string }) => {
  const navigate = useNavigate();
  const bodyRef = useRef<HTMLDivElement>(null);

  // Vừa đổi bước: đưa con trỏ vào nội dung mới để trình đọc màn hình đọc ngay kết quả.
  useEffect(() => {
    bodyRef.current?.focus({ preventScroll: true });
  }, []);

  const steps: AuthStepItem[] = [
    {
      title: ADMIN_ACCESS_STEPS[0].title,
      description: (
        <>
          Xong: <strong className={styles.strong}>{email}</strong> đã được xác minh, dùng được ngay
          trong app HP Media.
        </>
      ),
    },
    ...ADMIN_ACCESS_STEPS.slice(1),
  ];

  return (
    <div ref={bodyRef} tabIndex={-1} className={styles.done}>
      <AuthSuccessBadge />
      <h2 className={styles.sectionTitle}>Cách được cấp quyền quản trị</h2>
      <AuthSteps items={steps} />

      <Button
        type="primary"
        size="large"
        block
        className={styles.doneButton}
        onClick={() => navigate(paths.login, { state: { email } })}
      >
        Về trang đăng nhập
      </Button>

      <AuthNote>
        Đợi Admin cấp quyền rồi hãy đăng nhập ở đây. Đăng nhập trước đó sẽ bị từ chối, và còn đăng
        xuất tài khoản khỏi app HP Media trên điện thoại.
      </AuthNote>
    </div>
  );
};

export default DoneStep;
